import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { FormGroup } from '../../../common-components';
import messages from '../../messages';

const WorkContextField = (props) => {
  const { formatMessage } = useIntl();
  const {
    value,
    handleChange,
    handleErrorChange,
    errorMessage,
    required = true,
    name = 'work_context',
  } = props;

  const OPTIONS = [
    { value: '', label: formatMessage(messages['registration.work_context.label']) },
    { value: 'kg', label: formatMessage(messages['work.context.kg']) },
    { value: 'ps', label: formatMessage(messages['work.context.ps']) },
    { value: 'ss', label: formatMessage(messages['work.context.ss']) },
    { value: 'ti', label: formatMessage(messages['work.context.ti']) },
    { value: 'nas', label: formatMessage(messages['work.context.nas']) },
    { value: 'phs', label: formatMessage(messages['work.context.phs']) },
    { value: 'pnhs', label: formatMessage(messages['work.context.pnhs']) },
    { value: 'st', label: formatMessage(messages['work.context.st']) },
    { value: 'stnh', label: formatMessage(messages['work.context.stnh']) },
    { value: 'other', label: formatMessage(messages['education.level.other']) },
  ];

  const handleOnChange = (e) => {
    handleChange({ target: { name, value: e.target.value } });
    if (errorMessage) handleErrorChange(name, '');
  };

  const handleOnBlur = (e) => {
    if (required && !e.target.value) {
      handleErrorChange(
        name,
        formatMessage(messages['empty.work_context.field.error'])
      );
    }
  };

  const handleOnFocus = () => {
    handleErrorChange(name, '');
  };

  const renderOptions = () => (
    <>
      {OPTIONS.map((opt, index) => (
        <option
          key={opt.value || index}
          value={opt.value}
          disabled={opt.value === ''}
          hidden={opt.value === '' && value !== ''}
        >
          {opt.label}
        </option>
      ))}
    </>
  );

  return (
    <FormGroup
      as="select"
      name={name}
      value={value}
      handleChange={handleOnChange}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
      errorMessage={errorMessage}
      floatingLabel={formatMessage(messages['registration.work_context.label'])}
      options={renderOptions}
    />
  );
};

WorkContextField.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
};

WorkContextField.defaultProps = {
  value: '',
  errorMessage: '',
};

export default WorkContextField;
